/**
 * @desc: -  团队管理
 * @author: danny
 */

import {DateGroup,RangeGroup,SearchGroup,Pagintaion,Bread} from "./ReportComponent.jsx";
import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as baseAction from '../../../actions/baseAction'
import * as userAction from '../../../actions/userAction'
import * as commonAction from "../../../actions/commonAction";
import * as reportAction from "../../../actions/reportAction";
import ReportBase from './ReportBase.jsx'
import TeamRegister from './popPage/TeamRegister.jsx'
import TeamLink from './popPage/TeamLink.jsx'
import Popup from "../../../components/modal/popup.jsx";

class TeamManeger extends ReportBase{
	constructor(props){
		super(props)
		
	}
	
	refer(){
		const {startDate,endDate,rangeIndex,pageNum,orderBy,sort,rangeOptionValue,searchValue} = this.state;
		this.props.$$REPORT.getTeamUserList(
			0,
			0,
			searchValue,
			0,
			pageNum,
			orderBy,
			sort
		);
	}
	
	
	render(){
		const __base = this.props.__BASE.toJS();
		const __report = this.props.__REPORT.toJS();
		
		if(!__report.current_view ) return <div></div>
		const {searchValue,orderBy,sort,popUpCurrent} = this.state;
		
		return <div className="team-maneger-container report-commer-container">
			<div className="title-warp">
				<h6 className="title">团队管理</h6>
				
			</div>
			
			<div className="tool-warp">
				<SearchGroup onChange={this.searchChange}/>
				<label onClick={()=>{this.popUpToggle("link")}} className="blue-button"><i className="reg-icon"></i><span>推广链接</span></label>
				<label onClick={()=>{this.popUpToggle("register")}} className="blue-button"><i className="pro-icon"></i><span>注册开户</span></label>
				{/*<label className="warming-color"><i className="warming-icon"></i>选择查询条件之后进行查询</label>*/}
			</div>
			
			<div className="info-warp">
				<label>本级 : <Bread onChange={this.breadChange} bread={__report.current_view.bread}/></label>
				
				<label className="warming-color"><i className="warming-icon"></i>选择查询条件之后进行查询</label>
			</div>
			 <div className="table-warp">
				<div className="table-title-warp">
					<label className={orderBy != "username"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('username')}>用户名<i/></label>
					<label className={orderBy != "userpoint"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('userpoint')}>	返点<i/></label>
					<label className={orderBy != "children_num"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('children_num')}>团队人数<i/></label>
					<label className={orderBy != "availablebalance"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('availablebalance')}>个人余额<i/></label>
					<label className={orderBy != "team_balance"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('team_balance')}>团队余额<i/></label>
					<label className={orderBy != "registertime"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('registertime')}>注册日期<i/></label>
					<label className={orderBy != "lasttime"?"":sort == 'desc' ?"active-up":"active-down"}
					       onClick={()=>this.tableTitleClick('lasttime')}>最后登录日期<i/></label>
					<label>操作<i/></label>
				</div>
				{
					__report.current_view.users && __report.current_view.users.map((item,index)=>{
						return <div className="title-body-warp" key={index}>
							<label>{item.username}</label>
							<label>{_.round((item.userpoint * 100), 1)}%</label>
							<label>{item.children_num}</label>
							<label>{item.availablebalance}</label>
							<label>{_.round(item.team_balance, 4)}</label>
							<label>{item.registertime}</label>
							<label>{item.lasttime}</label>
							<label>
								{
									['投注记录','帐变记录'].map((item,index) => {
										return <span className="operate" key={index}>{item}</span>
									})
								}
							</label>
							
						</div>
					})
				}
				
				{/*<div className="title-footer-warp">
					<label>本页合计</label>
					<label>187307.00</label>
					<label>590.000</label>
					<label>&nbsp;</label>
				</div>
				<div className="title-footer-warp">
					<label>总合计</label>
					<label>187307.00</label>
					<label>590.000</label>
					<label>&nbsp;</label>
				</div>*/}
				
				 <Popup display={popUpCurrent == "register"} className="indexPobup" width={650}  height={380} onclose={()=>{this.popUpToggle('none')}}>
					 <TeamRegister></TeamRegister>
				 </Popup>
				 <Popup display={popUpCurrent == "link"} className="indexPobup" width={650}  height={450} onclose={()=>{this.popUpToggle('none')}}>
					 <TeamLink></TeamLink>
				 </Popup>
			</div>
			
			{
				this.renderPage('')
			}
		</div>
	}
}
reactMixin(TeamManeger.prototype, ImmutableMixin);

function mapStateToProps(state) {
	return {
		__BASE: state.base,
		__USER: state.user,
		__REPORT:state.report
	}
}

function mapDispatchToProps(dispatch) {
	return {
		$$USER: bindActionCreators(userAction, dispatch),
		$$COMMON: bindActionCreators(commonAction, dispatch),
		$$BASE: bindActionCreators(baseAction, dispatch),
		$$REPORT:bindActionCreators(reportAction, dispatch),
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TeamManeger)
